export const domains: Record<string, string> = {
  'returns.misako.com': 'misako-shopify',
  'returns.ballester.me': 'partner-with-payments',
  'returns.thehoffbrand.com': 'thehoffbrand',
  'returns.burritoblanco.com': 'burritoblanco',
  'returns.sansarushop.com': 'sansaru',
  'returns.alvaromoreno.com': 'alvaromoreno',
  'returns.pikolinos.com': 'pikolinos',
  'retours.poli.fr': 'poli',
  'retours-decathlon.poli.fr': 'polidecathlon'
}
